import { getRedirectionParameters } from '@app/src/hooks/solutionAutoLogin'
import type { AppState } from '@auth0/auth0-react'
import { Auth0Provider } from '@auth0/auth0-react'
import type { PropsWithChildren } from 'react'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { Config } from './config'

const Authentication: React.FC<PropsWithChildren> = ({ children }) => {
  const history = useHistory()

  // A function that routes the user to the right place
  // after login
  const onRedirectCallback = (appState?: AppState) => {
    // grabbing the querystring from the appstate
    const [path, queryString] = (appState?.targetUrl ?? '').split(/\?(.*)/)

    const { redirectTo, loginParams } = getRedirectionParameters(path, queryString)

    history.push(
      appState && appState.targetUrl && (redirectTo !== '/' || loginParams !== '')
        ? `/?redirectTo=${encodeURIComponent(redirectTo)}${loginParams}`
        : redirectTo || '/',
    )
  }

  return (
    <Auth0Provider
      domain={Config.AUTH0_DOMAIN || ''}
      clientId={Config.AUTH0_CLIENT_ID || ''}
      audience={Config.AUTH0_AUDIENCE}
      redirectUri={window.location.origin}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens
    >
      {children}
    </Auth0Provider>
  )
}

export default Authentication
